import React from 'react'
import { PayloadAction, combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { ThunkAction } from 'redux-thunk'

import auth0, { initialState as auth0InitialState } from './modules/auth0/auth0.slice'

export const initialState = {
    auth0: auth0InitialState,
}

export const reducers = {
    auth0,
}

export const rootReducer = combineReducers(reducers)

const store = configureStore({
    reducer: rootReducer,
    middleware: [
        ...getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }),
    ] as const, // prevent this from becoming just `Array<Middleware>`
    devTools: false,
})

export type RootState = ReturnType<typeof rootReducer>

// eslint-disable-next-line
export type AppThunk = ThunkAction<Promise<void>, RootState, never, PayloadAction<any>>

export type AppDispatch = typeof store.dispatch

export const Auth0Context = React.createContext(null)

export default store
